import React from 'react';

import { CONTRACT_APPRAISAL_CONTINGENCY } from '@/config/constants';
import { getAppraisalClauseTerms } from '@/utils/appraisalClause';
import { ClauseText } from './Components/ContractText';

interface Props {
  daysFromExecutionDate?: number;
  daysForAppraisalNegotiation?: number;
  appraisalContingency?: CONTRACT_APPRAISAL_CONTINGENCY;
}

const Appraisal = ({
  daysFromExecutionDate,
  daysForAppraisalNegotiation,
  appraisalContingency,
}: Props) => {
  const terms = getAppraisalClauseTerms(appraisalContingency);
  const reportDays = <ClauseText>{daysFromExecutionDate ?? 'N/A'}</ClauseText>;
  const negotiationDays = (
    <ClauseText>{daysForAppraisalNegotiation ?? 'N/A'}</ClauseText>
  );

  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Appraisal Contingency
      </h2>
      {!terms.contingent ? (
        <p className="text-black mb-4 text-base">
          <ClauseText>{terms.statement}</ClauseText>
        </p>
      ) : (
        <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
          <li>
            <ClauseText>{terms.statement}</ClauseText>
          </li>
          <li>
            The Appraisal report must be completed within {reportDays} days of
            the executed date of this contract, not including the executed date
            of this contract.
          </li>
          <li>
            If the Property does not appraise at or above {terms.requiredAmount}
            , Buyer may terminate this Contract by providing written notice to
            Seller within {negotiationDays} days after Buyer's receipt of the
            appraisal report, providing that the Appraisal Report is received
            within {reportDays} days from the date of execution of this
            Contract.
          </li>
          <ol className="ml-4 text-black mb-2 text-base list-decimal list-inside text-bold">
            <li>
              If Buyer terminates this Contract under this provision within{' '}
              {negotiationDays} days after Buyer's receipt of the appraisal
              report, the earnest money shall be returned to Buyer.
            </li>
            <li>
              If Buyer does not terminate this Contract under this provision
              within {negotiationDays} days after Buyer's receipt of the
              appraisal report, the Contract shall proceed to Closing.
            </li>
            <li>
              If the Property appraises for less than {terms.requiredAmount},
              Buyer may terminate this Contract or negotiate Purchase Price by
              providing written notice to Seller within {negotiationDays} days
              after Buyer's receipt of the appraisal report.
            </li>
            <ol className="ml-4 text-black mb-2 text-base list-decimal list-inside text-bold">
              <li>
                Seller has {negotiationDays} days not including the date of
                receipt of written notice of new Purchase Price to counter offer
                or accept.
              </li>
              <li>
                Both parties, Buyer and Seller are to be provided with a copy of
                the completed Appraisal Report.
              </li>
              <li>
                If either party prepares a reconsideration of value with
                comparable properties, the appraisal contingency timeline for
                any new appraisal report with a reconsideration of value is
                extended until receipt of the new appraisal report with a
                reconsideration of value.
              </li>
              <li>
                Upon receipt of an updated appraisal report without sufficient
                Appraiser's Opinion of Value, after a reconsideration of value
                request, Buyer retains right to terminate the purchase contract
                according to the terms of the Appraisal Contingency and has{' '}
                {negotiationDays} days upon receipt of the updated appraisal
                report to terminate the contract.
              </li>
              <li>
                Upon receipt of an updated appraisal report with sufficient
                Appraiser's Opinion of Value at or above {terms.requiredAmount},
                after a reconsideration of value request, Buyer forgoes the
                right to terminate the purchase contract according to the terms
                of the Appraisal Contingency.
              </li>
            </ol>
          </ol>
        </ol>
      )}
    </div>
  );
};

export default Appraisal;
